// 거시 이벤트 대표 선택 규칙 — UI 훅과 API 응답이 공유하는 순수 도메인 계약

export interface MacroEventLite {
  id: string;
  country: string;
  event_type: string;
  title: string;
  event_date: string;
  vote_opens_at: string;
  vote_closes_at: string;
  status: 'upcoming' | 'voting' | 'locked' | 'resolved' | 'unresolved';
  outcome: 'hike' | 'hold' | 'cut' | null;
  dist: { hike: number; hold: number; cut: number };
  my_pick: 'hike' | 'hold' | 'cut' | null;
  my_correct: boolean | null;
}

// 마감임박(voting) 이벤트 1건 — RPC가 마감임박순으로 정렬한다는 API 계약에 의존한다.
export function pickPrimaryEvent(events: MacroEventLite[]): MacroEventLite | null {
  const voting = events.filter((event) => event.status === 'voting');
  if (voting.length) return voting[0];
  return events[0] || null;
}
